module.exports = __webpack_public_path__ + "img/LV.4fd871ca.svg";